import { headers } from "@utils/utils";
const useMaterialStore = defineStore("material", () => {
  // state
  const material = ref({
    id: null,
    nombre: "",
    descripcion: "",
    tipos: [],
    con_archivos: true,
    archivos: [],
    activo: true,
    descargas: 0,
    imagenes: [],
    portada: null,
  });

  const materiales = ref([]);

  // getters
  const draft = computed(() => clone(material.value));

  // methods
  const setMaterial = (data) => {
    material.value = data;
  };

  const setMateriales = (materials) => {
    materiales.value = materials;
  };

  const quitarImagen = (imagen_id) => {
    let i = material.value.imagenes.findIndex((v) => v.id === imagen_id);
    if (i != -1) {
      material.value.imagenes.splice(i, 1);
    }
  };

  const clear = () => {
    material.value = {
      id: null,
      nombre: "",
      descripcion: "",
      tipos: [],
      con_archivos: true,
      archivos: [],
      activo: true,
      descargas: 0,
      imagenes: [],
      portada: null,
    };
  };

  // methods actions

  const pushImagen = (data) => {
    material.value.imagenes.push(data);
  };

  const fetch = async (material_id) => {
    try {
      const { data } = await axios.get(
        `/api/materials/${material_id}/fetch-data`
      );

      if (data.id) {
        setMaterial(data);
      }

      return data;
    } catch (error) {
      console.log("Error fetching product:", error);

      throw error;
    }
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/materials/fetch-data`, params)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const guardar = async (datos) => {
    try {
      let formData = new FormData();

      Object.keys(datos).forEach((key) => {
        if (key == "tipos") {
          datos[key].forEach((val) => {
            formData.append("tipos[]", val);
          });
        }
        formData.append(key, datos[key]);
      });

      if (datos.id) {
        formData.append("_method", "PUT");
        const { data } = await axios.post(
          `/api/materials/${datos.id}`,
          formData,
          { headers }
        );
        if (data.result) {
          setMaterial(data.material);
        }
        return data;
      } else {
        const { data } = await axios.post(`/api/materials`, formData, {
          headers,
        });
        if (data.result) {
          setMaterial(data.material);
          materiales.value.push(data.material);
        }
        return data;
      }
    } catch (error) {
      throw error;
    }
  };

  const eliminar = (material_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/materials/${material_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const eliminarImagen = (imagen_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/imagens/${imagen_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const cargarImagen = ({ imagenes }) => {
    let formData = new FormData();

    imagenes.forEach((val) => {
      formData.append("imagen[]", val);
    });

    formData.append("_method", "put");

    return new Promise((resolve, reject) => {
      axios
        .post(`/api/materials/${material.value.id}/cargar/imagen`, formData, {
          headers,
        })
        .then(({ data }) => {
          if (data.result) {
            setMaterial(data.material);
          }

          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const cargarArchivos = async (material_id) => {
    try {
      const { data } = await axios.get(
        `/api/materials/${material_id}/get/archivos`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const uploadArchivos = async (material_id, file) => {
    let formData = new FormData();

    formData.append("archivo", file);
    formData.append("_method", "put");

    return new Promise((resolve, reject) => {
      axios
        .post(`/api/materials/${material_id}/cargar/archivo`, formData, {
          headers,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const montarZip = async (material_id) => {
    try {
      const { data } = await axios.get(
        `/api/materials/${material_id}/montar/zip`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const eliminarArchivo = async (mat_id, archivo_name) => {
    try {
      const { data } = await axios.put(
        `/api/materials/${mat_id}/eliminar/archivo`,
        { archivo_name }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    // state,
    material,
    materiales,
    // methods
    setMaterial,
    setMateriales,
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    pushImagen,
    cargarImagen,
    eliminarImagen,
    quitarImagen,
    cargarArchivos,
    uploadArchivos,
    montarZip,
    eliminarArchivo,
  };
});

export default useMaterialStore;
